import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "room-navigator room-navigator-skeleton" }


export default {
  __name: 'RoomNavigatorSkeleton',
  setup(__props) {

// No props or logic needed for skeleton

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"room-navigator-content\"><div class=\"nav-section\"><div class=\"skeleton-button skeleton-dashboard\"></div></div><div class=\"nav-section\"><div class=\"skeleton-select skeleton-building\"></div></div><div class=\"nav-section\"><div class=\"room-controls\"><div class=\"skeleton-button nav-arrow\"></div><div class=\"skeleton-select skeleton-room\"></div><div class=\"skeleton-button nav-arrow\"></div></div></div></div>", 1)
  ]))]))
}
}

}